export const STORAGE_PREFIX = "sportypost_page_state_";

/**
 * Generates the full localStorage key for a given page key.
 */
export const getStorageKey = (key: string) => `${STORAGE_PREFIX}${key}`;

/**
 * Removes a specific page state from localStorage.
 */
export const removePageState = (key: string) => {
  if (typeof window === "undefined") return;
  
  try {
    const storageKey = getStorageKey(key);
    window.localStorage.removeItem(storageKey);
  } catch (error) {
    console.warn(`Error removing localStorage key "${getStorageKey(key)}":`, error);
  }
};

/**
 * Removes all page states from localStorage that match the prefix.
 * Returns the number of items removed.
 */
export const removeAllPageStates = (): number => {
  if (typeof window === "undefined") return 0;

  let count = 0;
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith(STORAGE_PREFIX)) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => {
      window.localStorage.removeItem(key);
      count++;
    });
  } catch (error) {
    console.warn("Error resetting all page states:", error);
  }
  return count;
};
